import {Breadcrumb, Col, Dropdown, Row, Spinner} from 'react-bootstrap'
import {defineMessages, useIntl} from 'react-intl'

/**
 * Llaves NUEVAS consumidas via el helper `t()` (el extractor no sigue wrappers, guia 17.12).
 * Las de `policies.detail.section.*` las reutilizara OnePolicyPage (B8) para su const SECTIONS.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const M = defineMessages({
  quote: {id: 'policies.detail.loading.quote', defaultMessage: 'Quote'},
  options: {id: 'policies.detail.loading.options', defaultMessage: 'Options'},
  action: {id: 'policies.detail.loading.action', defaultMessage: 'Action'},
  state: {id: 'policies.detail.summary.state', defaultMessage: 'State:'},
  householdTitle: {
    id: 'policies.detail.holder.householdTitle',
    defaultMessage: 'Household Information',
  },
  insurancePayment: {
    id: 'policies.detail.loading.insurancePayment',
    defaultMessage: 'Insurance & Payment',
  },
  sectionPolicyForm: {id: 'policies.detail.section.policyForm', defaultMessage: 'Policy Form'},
  sectionDocuments: {id: 'policies.detail.section.documents', defaultMessage: 'Documents'},
  sectionNotes: {id: 'policies.detail.section.notes', defaultMessage: 'Notes'},
  sectionReminders: {id: 'policies.detail.section.reminders', defaultMessage: 'Reminders'},
  sectionCommissions: {id: 'policies.detail.section.commissions', defaultMessage: 'Commissions'},
})

export const LoadingOnePolicy = () => {
  const intl = useIntl()
  const t = (id: string, defaultMessage: string) => intl.formatMessage({id, defaultMessage})
  return (
    <div>
      <header
        className='py-4 d-flex align-items-center justify-content-between'
        style={{width: '100%', marginTop: '-10px'}}
      >
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none'>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{t('policies.detail.loading.quote', 'Quote')}</Breadcrumb.Item>
          <Breadcrumb.Item active>
            {t('policies.detail.loading.quote', 'Quote')} <Spinner animation='border' size='sm' className='ms-3' />
          </Breadcrumb.Item>
        </Breadcrumb>

        <Dropdown>
          <Dropdown.Toggle variant='primary' size='sm' id='dropdown-basic' disabled>
            {t('policies.detail.loading.options', 'Options')}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href='#/action-1'>{t('policies.detail.loading.action', 'Action')}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </header>
      <div className='mt-4'>
        <Row>
          <Col md={4} lg={4} sm={0} xl={3} className='d-none d-md-block'>
            <div
              style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                boxShadow: '0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)',
                backgroundColor: '#fff',
                marginBottom: '20px',
                borderRadius: '4px',
                padding: '8px 10px',
              }}
            >
              <div className='kt-widget__content pt-0'>
                <div className='kt-heading kt-heading--sm custom-border-brand my-3'>
                  {t('policies.detail.summary.titlePolicy', 'Policy Summary')}
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.agentOwner', 'Agent (Owner):')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.assignTo', 'Assign To:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.createdBy', 'Created by:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.internalCode', 'Internal code:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.state', 'State:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.list.page.cell.carrier', 'Carrier:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.effective', 'Effective date:')}</span>
                  <span className='kt-widget__data' id='effective_label'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.applicants', 'Number of applicants:')}</span>
                  <span className='kt-widget__data' id='no_applicants'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.status', 'Status:')}</span>
                  <span className='kt-widget__data' id='policy_status_label'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.documentsStatus', 'Documents status:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.paymentStatus', 'Payment status:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.summary.lastUpdate', 'Last update:')}</span>
                  <span className='kt-widget__data' id='last_update_label'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-heading kt-heading--sm custom-border-brand my-3'>
                  {t('policies.detail.holder.householdTitle', 'Household Information')}
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.holder.holder', 'Holder:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.holder.dateOfBirth', 'Date of birth:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('common.field.phone', 'Phone')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.holder.location', 'Location')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.form.member.employment.annualIncome', 'Annual income')}</span>
                  <span className='kt-widget__data' id='household_income_label'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
                <div className='kt-widget__info'>
                  <span className='kt-widget__label'>{t('policies.detail.holder.memberId', 'Member ID:')}</span>
                  <span className='kt-widget__data'>
                    <span
                      className='placeholder-glow'
                      style={{
                        width: '120px',
                        display: 'inline-block',
                      }}
                    >
                      <span className='placeholder col-12' />
                    </span>
                  </span>
                </div>
              </div>

              <div>
                <ul className='nav flex-column nav-pills w-100'>
                  {[
                    {name: t('policies.detail.section.policyForm', 'Policy Form'), icon: 'person-fill'},
                    {name: t('policies.detail.section.documents', 'Documents'), icon: 'folder-fill'},
                    {name: t('policies.detail.section.notes', 'Notes'), icon: 'pencil-square'},
                    {name: t('policies.detail.section.reminders', 'Reminders'), icon: 'arrow-repeat'},
                    {name: t('policies.detail.section.commissions', 'Commissions'), icon: 'cash-stack'},
                  ].map((tabl) => (
                    <li className='nav-item w-100 py-2' key={tabl.name}>
                      <button
                        style={{textAlign: 'left', opacity: 0.5}}
                        className={`nav-link w-100 d-flex align-items-center gap-2`}
                        aria-current='page'
                        disabled
                      >
                        <span>
                          <i className={`bi bi-${tabl.icon} fs-4`} style={{color: 'inherit'}} />
                        </span>
                        <span>{tabl.name}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col md={8} lg={8} sm={12} xl={9}>
            <div>
              <div className='d-flex flex-column gap-2 flex-xl-row'>
                {[
                  {
                    div: [
                      {num: 1, name: t('policies.detail.form.tab.policyHolder', 'Policy holder')},
                      {num: 2, name: t('policies.detail.form.tab.members', 'Members')},
                    ],
                  },
                  {
                    div: [
                      {num: 3, name: t('policies.detail.loading.insurancePayment', 'Insurance & Payment')},
                      {num: 4, name: t('policies.detail.form.tab.extras', 'Extras')},
                    ],
                  },
                ].map(({div}, i) => (
                  <div key={i} className='d-flex flex-column flex-md-row' style={{flex: 1}}>
                    {div.map((d) => (
                      <button
                        key={d.num}
                        className='btn d-flex align-items-center gap-2 btn-block bg-white'
                        style={{
                          flex: 1,
                          boxShadow: '0 -1px 3px 0 rgba(0,0,0,0.12), 0 -1px 3px 0 rgba(0,0,0,0.12)',
                          opacity: 0.3,
                        }}
                        disabled
                      >
                        <span
                          style={{
                            fontSize: '1.3rem',
                            fontWeight: 600,
                            flex: '0 0 2.75rem',
                            height: '2.75rem',
                            width: '2.75rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(93, 120, 255, 0.08)',
                            color: '#5d78ff',
                            marginRight: '1rem',
                            borderRadius: ' 0.5rem',
                          }}
                        >
                          {d.num}
                        </span>
                        <span style={{color: 'gray'}}>{d.name}</span>
                      </button>
                    ))}
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexGrow: 1,
                  flexDirection: 'column',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)',
                  backgroundColor: '#fff',
                  marginBottom: '20px',
                  borderRadius: '4px',
                  padding: '8px 10px',
                }}
              >
                <div className='d-flex flex-center' style={{height: '50vh'}}>
                  <Spinner animation='border' />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
